export const SPAM = 'SPAM';
export const BLOCK = 'BLOCK';